<div class="flex flex-col">
  @if (quoteRequestForm !== undefined && completedQuoteRequest() !== null) {
    <div class="flex flex-col items-center mt-8">
      <!-- Confirmation Icon and Message -->
      <div class="flex flex-row w-full gap-4 items-center p-2">
        <img src="assets/icons/check.svg" alt="Checkmark" class="h-25 w-15">
        <div class="flex flex-col justify-center">
          <div class="text-gray-500 text-md sm:text-sm">
              Confirmation #{{ completedQuoteRequest()?.order_number?.toString() || 'PENDING' }}
          </div>
          <h1 class="text-3xl sm:text-xl font-bold">Request Received!</h1>
        </div>
      </div>

      <!-- Request Details Card -->
      <mat-card class="w-full max-w-2xl border border-gray-200 shadow-sm mt-4">
        <mat-card-header>
          <mat-card-title class="text-lg font-semibold">Your request is confirmed</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <p class="my-2">
            Thank you for submitting your request. We will get back to you shortly with your quote.
          </p>
          <p class="my-2">
            You will receive an email as soon as your quote is ready. We recommend that you add
            <a href="mailto:service@suretybondsdirect.com?subject=Surety Bond Quote Request {{ completedQuoteRequest()?.order_number || '' }}"
               class="text-primary hover:underline">
              service&#64;suretybonds.com
            </a>
            to your address book to ensure that you receive your quote as quickly as possible.
          </p>
        </mat-card-content>
      </mat-card>

      <!-- Actions (vertical) -->
      <div class="flex flex-col gap-3 items-stretch justify-center mt-6 w-full max-w-2xl">
        <button mat-stroked-button color="primary" (click)="onRequestAnotherForThisPrincipal()">
          Make another request for this Principal
        </button>
        <button mat-stroked-button color="primary" (click)="onRequestAnotherWithSameBond()">
          Make another request for a {{ getSelectedBondLabel() || 'selected bond' }}
        </button>
        <button mat-stroked-button color="primary" (click)="onRequestAnother()">
          Make another request starting from scratch
        </button>
        <button mat-stroked-button color="primary" (click)="onDone()">
          I'm done
        </button>
      </div>
    </div>
  } @else {
    <!-- Error State -->
    <mat-card class="w-full max-w-2xl border border-red-200 shadow-sm mt-4 mx-auto">
      <mat-card-header>
        <mat-card-title class="text-lg font-semibold text-red-600">Error Processing Request</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p>
          There was an error processing your request. Please try again or contact support at
          <a href="mailto:service@suretybonds.com" class="text-primary hover:underline">
            service&#64;suretybonds.com
          </a>
        </p>
      </mat-card-content>
    </mat-card>
  }
</div>
